import React from "react";
import capitalize from "../../../Utils/capitalize";

const ItemBody26 = ({ notification }) => {
  return (
    <div className="min-h-20">
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium">
          Rental trip {notification?.metaData?.rentalId}:
        </span>{" "}
        Vehicle
        <span className="font-medium">
          {" "}
          {notification?.metaData?.trikeRegistrationNo}{" "}
        </span>
        was received by{" "}
        <span className="font-medium">
          {capitalize(notification?.metaData?.receivedBy || "hub manager")}
        </span>{" "}
        at {capitalize(notification?.metaData?.hubName || "hub station")}.
      </p>
    </div>
  );
};

export default ItemBody26;
